import { TechnicalFaultTypes } from "../Constants";

export const TechnicalFaultType = {
  name: "technical-fault-type",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "technicalFault.type",
  showOn: [{ state: "primary", value: "technical-fault-type", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showDetails: {},
  children: [
    {
      name: "technical-fault-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "subType",
        children: TechnicalFaultTypes,
        layout: "type-button",
        prefix: "technicalFault",
      },
      actionGroups: [
        {
          actions: [
            { action: "deleteFromPlay", value: "steal", type: "main" },
            { action: "deleteFromPlay", value: "turnover", type: "main" },
            { action: "clearData", value: ["subType"], type: "main" },
            { action: "copyEvent", value: "steal", type: "to" },

            { action: "deleteFromPlay", value: "technicalFault", type: "main" },
            {
              action: "deleteFromInsertStore",
              value: "technicalFault",
              type: "eventType",
            },

            { action: "newEventId", value: null, type: "main" },
            { action: "saveData", value: "turnover", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "fault", type: "to" },

            { action: "modifyEvent", value: "swapEntities", type: "steal" },
            { action: "copyEvent", value: "steal", type: "from" },
            { action: "newEventId", value: null, type: "main" },
            { action: "saveData", value: "steal", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            {
              action: "setPossession",
              value: { currentEntity: true },
              type: "main",
            },
            {
              action: "nextState",
              value: "steal-player",
              type: "primary",
            },
          ],
          conditions: [
            {
              item: "subType",
              value: "steal",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            {
              action: "nextState",
              value: "technical-fault-player",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "match-buttons",
      component: "ButtonPanel",
      layout: "match-buttons-stackable centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later-technical-fault-type",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          actionGroups: [
            {
              actions: [
                { action: "saveData", type: "flagged", value: true },
                { action: "sendEvent", value: "edit", type: "main" },
                {
                  action: "nextState",
                  value: "technical-fault-player",
                  type: "primary",
                },
              ],
              conditions: [],
            },
          ],
          startEvent: false,
          startPlay: false,
        },
      ],
    },
  ],
};
